export class ErrorMessage {
    public "error_api_login_errorSessionExpired": string = "Votre session a expiré. Veuillez vous reconnecter";

    public "error_api_viewerPDF_errorMessageDownloadDocument": string = "Une erreur est survenue. Nous n'avons pas trouvé le document demandé.";

    public "error_api_Residence_errorMessageGetManyResidenceActualites": string = "Une erreur est survenue. Nous n'avons pas trouvé le dossier de vente demandé.";

    public document_uploadingDocument = "Une erreur s'est produite lors de l'upload du document. Veuillez réessayer"
    public document_pleaseLoadDocument = "Veuillez charger un document"

    
}